"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const PaymentWidgetMixin_1 = require("@/client/mixins/PaymentWidgetMixin");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PaymentUnitComponent',
    props: {
        modelValue: {
            type: Number,
            required: true,
        },
        unit: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        showMax: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
    components: {
        AppButton: AppButton_vue_1.default,
    },
    methods: {
        ...PaymentWidgetMixin_1.PaymentWidgetMixin.methods,
    },
    computed: {
        iconClass() {
            switch (this.unit) {
                case 'kuiperAsteroids': return 'resource_icon--asteroid';
                case 'lunaArchivesScience': return 'resource_icon--science';
                case 'spireScience': return 'resource_icon--science';
                case 'auroraiData': return 'resource_icon--auroraidata';
                case 'seeds': return 'resource_icon--seed';
                case 'megaCredits': return 'resource_icon--megacredits';
                default: return 'resource_icon--' + this.unit;
            }
        },
    },
});
